export const PROFILE_REQUEST = 'profileRequest';
export const PROFILE_LOADING = 'profileLoading';
export const PROFILE_SUCCESS = 'profileSuccess';
export const PROFILE_ERROR = 'profileError';
export const CHECK_PERSONAL = 'checkPersonal';
export const POST_PROFILE = 'postProfile';
export const POST_MARITAL_STATUS = 'postMaritalStatus';
export const MARITAL_STATUS_REQUEST = 'maritalStatusRequest';
export const MARITAL_STATUS_LOADING = 'maritalStatusLoading';
export const MARITAL_STATUS_SUCCESS = 'maritalStatusSuccess';
export const MARITAL_STATUS_ERROR = 'maritalStatusError';
export const POST_ADDRESS = 'postAddress';
export const ADDRESS_REQUEST = 'addressRequest';
export const ADDRESS_LOADING = 'addressLoading';
export const ADDRESS_SUCCESS = 'addressSuccess';
export const ADDRESS_ERROR = 'addressError';
export const POST_COMPLIANCE_STATUS = 'postComplianceStatus';
export const COMPLIANCE_STATUS_REQUEST = 'complianceStatusRequest';
export const COMPLIANCE_STATUS_LOADING = 'complianceStatusLoading';
export const COMPLIANCE_STATUS_SUCCESS = 'complianceStatusSuccess';
export const COMPLIANCE_STATUS_ERROR = 'complianceStatusError';
export const POST_LEVY = 'postLevy';
export const AMOUNT_OWED_REQUEST = 'amountOwedRequest';
export const AMOUNT_OWED_LOADING = 'amountOwedLoading';
export const AMOUNT_OWED_SUCCESS = 'amountOwedSuccess';
export const AMOUNT_OWED_ERROR = 'amountOwedError';
export const LEVY_REQUEST = 'levyRequest';
export const LEVY_SUCCESS = 'levySuccess';
export const POST_NEW_AMOUNT_OWED_ITEM = 'postNewAmountOwedItem';
export const NEW_AMOUNT_OWED_SUCCESS = 'newAmountOwedSuccess';
export const DELETE_AMOUNT_OWED_ITEM = 'deleteAmountOwedItem';
export const DELETE_AMOUNT_SUCCESS = 'deleteAmountSuccess';
export const EDIT_AMOUNT_OWED_ITEM = 'editAmountOwedItem';
export const EDIT_AMOUNT_OWED_SUCCESS = 'editAmountOwedSuccess';
export const POST_CLAIMED_DEPENDENTS = 'postClaimedDependents';
export const CLAIMED_DEPENDENTS_REQUEST = 'claimedDependentsRequest';
export const CLAIMED_DEPENDENTS_LOADING = 'claimedDependentsLoading';
export const CLAIMED_DEPENDENTS_SUCCESS = 'claimedDependentsSuccess';
export const CLAIMED_DEPENDENTS_ERROR = 'claimedDependentsError';
export const PERSONAL_REQUESTS = 'personalRequests';
export const FILTER_AMOUNT_OWED_YEARS = 'filterAmountOwedYears';
export const SET_AMOUNT_OWED_YEARS = 'setAmountOwedYears';
export const COUNTIES_REQUEST = 'countiesRequest';
export const COUNTIES_SUCCESS = 'countiesSuccess';
export const POWER_OF_ATTORNEY_REQUEST = 'powerOfAttorneyRequest';
export const POWER_OF_ATTORNEY_SUCCESS = 'powerOfAttorneySuccess';
export const POWER_OF_ATTORNEY_ERROR = 'powerOfAttorneyError';
export const POST_REVENUE_OFFICER_FLAG = 'postRevenueOfficerFlag';
